import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

/**
 * Batch 1 Item 5 — Service-Worker update toast.
 *
 * Listens for the `sw-update-ready` window CustomEvent dispatched by the
 * vanilla-JS SW shim in `public/index.html`. Shows a persistent (non-auto-
 * dismissing) sonner toast with a "Refresh" action button.
 *
 * The user has full control over WHEN the reload happens, so any open
 * modal, unsaved form input, scroll position, or filter state is
 * preserved by default. The user only loses state if they themselves
 * click Refresh.
 */
export function SWUpdateToast() {
  const shownRef = useRef(false);

  useEffect(() => {
    const handler = () => {
      if (shownRef.current) return;
      shownRef.current = true;
      toast('App updated — refresh when ready', {
        description: 'A new version is available. Open work is preserved until you click Refresh.',
        duration: Infinity,
        dismissible: true,
        action: {
          label: 'Refresh',
          onClick: () => {
            if (typeof window.__refreshAppNow === 'function') {
              window.__refreshAppNow();
            } else {
              window.location.reload();
            }
          },
        },
      });
    };
    window.addEventListener('sw-update-ready', handler);
    return () => window.removeEventListener('sw-update-ready', handler);
  }, []);

  return null;
}
